// Website choices are deliberately narrower than the shared admin language catalog.
export const WEBSITE_LANGUAGES = [
  { langCode: 'zh_TW', langName: '繁體中文' },
  { langCode: 'zh_CN', langName: '简体中文' },
  { langCode: 'en_US', langName: 'English' },
];

export function websiteLocale(value) {
  const code = typeof value === 'string' ? value.trim().replace('-', '_').toLowerCase() : '';
  return WEBSITE_LANGUAGES.find(row => row.langCode.toLowerCase() === code)?.langCode || (code === 'en' || code.startsWith('en_') ? 'en_US' : 'zh_TW');
}

export function websiteLanguages(rows) {
  if (!Array.isArray(rows)) return [];
  return WEBSITE_LANGUAGES.map(choice => {
    const row = rows.find(item => item?.langCode === choice.langCode && (item.status == null || item.status === 1));
    return row ? { ...row, ...choice } : null;
  }).filter(Boolean);
}
